<template>
	<div class="f-text inputfield inputfield--password" v-if="field">
		<div class="row">
			<div class="col-xs-12 col-sm-6">
				<input
				class="st-input st-input--full"
				type="password"
				new-password="true"

				v-validate="getFieldValidation(field)"
				v-model="value"
				:autocomplete="field.autocomplete"

				:disabled="systemdisable"
				:class="{'st-input--error': errors.has(field.name)}"
				:id="field.name"
				:name="field.name"
				:placeholder="(field.placeholder ? $t(field.placeholder) : '')" />
			</div>
			<div class="col-xs-12 col-sm-6">
				<input
				class="st-input st-input--full"
				type="password"
				id="password_confirmation"
				name="password_confirmation"
				new-password="true"

				v-model="password_confirmation"
				:autocomplete="field.autocomplete"

				:disabled="systemdisable"
				:class="{'st-input--error': errors.has(field.name)}"
				:placeholder="$t('Password Confirmation')" />
			</div>
			<div class="col-xs-12">
				<div class="error" v-show="errors.has(field.name)">
					{{ errors.first(field.name) }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/**
 Password Confirmation
password_confirmation
 */

import fieldvalidation from '@/helpers/fieldvalidation';

export default {
	name: 'f-password',
	computed: {
		systemdisable(){
			let field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},
	  	value: {
		    get () {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		      	return field.value
		    },
		    set (value) {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		    	field.value = value;
		    }
		}
	},
	data(){
		return {
			password_confirmation: ''
		}
	},
	props: {
		field: {
			type: Object,
			default: function(){
				return {};
			}
		}
	},
	methods: {
		...fieldvalidation
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/f-password.vue